import { useABNCancellationStore } from '@stores/ABNCancellationStore.js'
import { useABNExtrasStore } from '@stores/ABNExtrasStore.js'
import { useABNUpdateDetailsStore } from '@stores/ABNUpdateDetailsStore.js'
import { useBNCancellationStore } from '@stores/BNCancellationStore.js'
import { useBNStore } from '@stores/BNStore.js'
import { useBNSuggestionsStore } from '@stores/BNSuggestionsStore.js'
import { useChatStore } from '@stores/ChatStore.js'
import { useDocumentsStore } from '@stores/DocumentsStore.js'
import { useErrorsStore } from '@stores/ErrorsStore.js'
import { useExtraServicesStore } from '@stores/ExtraServicesStore.js'
import { useFindStore } from '@stores/FindStore.js'
import { useGSTCancellationStore } from '@stores/GSTCancellationStore.js'
import { useGSTStore } from '@stores/GSTStore.js'
import { useIncludedServicesStore } from '@stores/IncludedServicesStore.js'
import { useIntakeStore } from '@stores/IntakeStore.js'
import { useLookupStore } from '@stores/LookupStore.js'
import { useNotificationsStore } from '@stores/NotificationsStore.js'
import { useOrderStore } from '@stores/OrderStore.js'
import { usePaymentStore } from '@stores/PaymentStore.js'
import { useProfileStore } from '@stores/ProfileStore.js'
import { useSubscriptionStore } from '@stores/SubscriptionStore.js'

/**
 * Reset every client/draft store to its defaults on sign-out (mirrors
 * FindForm's cleanup), so the previous user's data never lingers in the service
 * forms — this also clears the persisted copies in localStorage.
 */
export function resetClientStores() {
  useErrorsStore().setErrors({})
  useFindStore().resetData()
  useABNCancellationStore().resetData()
  useABNExtrasStore().resetData()
  useABNUpdateDetailsStore().resetData()
  useBNCancellationStore().resetData()
  useBNStore().resetData()
  useBNSuggestionsStore().reset()
  useExtraServicesStore().resetData()
  useGSTCancellationStore().resetData()
  useGSTStore().resetData()
  useIncludedServicesStore().reset()
  useLookupStore().resetData()
  useNotificationsStore().reset()
  useOrderStore().resetData()
  usePaymentStore().resetData()
  useProfileStore().reset()
  // Signed-in account surfaces (SUB-MVP-21/37/42/52): no longer reset on each
  // page mount (stale-while-revalidate), so clear them here on sign-out.
  useSubscriptionStore().reset()
  useDocumentsStore().reset()
  useChatStore().reset()
  useIntakeStore().reset()
}
